import styled from 'styled-components'

export const QualityIndication = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;

  span.toggle-link {
    text-decoration: underline;
    cursor: pointer;
    margin-bottom: 15px;
  }

  div.quality-indication-bargraph-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    line-height: 25px;
    margin-bottom: 30px;
    align-items: baseline;
    min-height: 30px;
    height: auto;

    @media screen and ${ (props) => props.theme.breakpoints.devices.max.sm } {
      flex-direction: column;
    }

    .single-peq-label {
      display: block;
      margin-bottom: 0;
      margin-right: 20px;
      width: 60%;

      @media screen and ${ (props) => props.theme.breakpoints.devices.min.sm } {
        display: inline-block;
        margin-bottom: 0;
        margin-right: 20px;
      }

      @media screen and ${ (props) => props.theme.breakpoints.devices.max.sm } {
        width: 100%;
      }

      .average-value {
        font-weight: bold;
      }
    }

    .bargraph-container {
      height: auto;
      width: auto;
      display: flex;
      position: relative;
      left: -10px;
      top: 5px;

      @media screen and ${ (props) => props.theme.breakpoints.devices.max.sm } {
        position: inherit;
        width: 100%;
        top: 0;
        margin-top: 10px;
      }

      .peq-bar-graph {
        width: 240px;
      }
    }
  }

  div.bargraph-footer {
    display: flex;

    &.space-between {
      justify-content: space-between;
    }

    &.left-align {
      justify-content: flex-start;
    }

    &.right-align {
      justify-content: flex-end;
    }

    div.treatments-container {
      display: flex;
      flex-direction: row;

      span.treatments-count-value {
        text-align: right;
        margin-bottom: 30px;
        margin-right: 8px;
      }

      div.tooltip-container {
        position: relative;
        top: 2px;
      }
    }

    span.toggle-link {
      margin-bottom: 30px;
    }
  }

  span.toggle-link,
  span.achievedValue-value {
    text-align: right;
    margin-bottom: 30px;
  }

  .headline {
    font-weight: bold;
    font-size: 18px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.39;
    letter-spacing: normal;
    color: ${ (props) => props.theme.colors['standard-schwarz'] };
  }
`
